<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/device' }">客户处设备</el-breadcrumb-item>
            <el-breadcrumb-item>编辑设备</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="所属企业" prop="epId" >
                    <el-select v-model="form.epId" placeholder="请选择">
                        <el-option
                                v-for="item in enterprises"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称" prop="name">
                    <el-col :span="8">
                        <el-select v-model="form.name" placeholder="请选择" @change="onNameSelect">
                            <el-option
                                    v-for="item in deviceNames"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="设备型号" prop="deviceTypeId" v-if="deviceTypes.length > 0">
                    <el-select v-model="form.deviceTypeId" placeholder="请选择">
                        <el-option
                                v-for="item in deviceTypes"
                                :key="item.id"
                                :label="item.model"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户类型" prop="shareState" >
                    <el-select v-model="form.shareState" placeholder="请选择">
                        <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="匿名操作" prop="shareState" v-if="form.shareState == 0">
                    <el-select v-model="form.anymousState" placeholder="请选择">
                        <el-option label="开启" :value="1"></el-option>
                        <el-option label="关闭" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品序列号" prop="serialNo">
                    <el-col :span="8">
                        <el-input v-model="form.serialNo"></el-input>
                    </el-col>
                </el-form-item>
                <!--<el-form-item label="机器号" prop="deviceId">
                    <el-col :span="8">
                        <el-input v-model="form.deviceId"></el-input>
                    </el-col>
                </el-form-item>-->
                <el-form-item label="产品录入序号" prop="snc">
                    <el-col :span="8">
                        <el-input v-model="form.snc"></el-input>
                    </el-col>
                </el-form-item>
                <!--<el-form-item label="ucKey3SKIP32" prop="uckey">
                    <el-col :span="8">
                        <el-input v-model="form.uckey"></el-input>
                    </el-col>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交更新</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/device";
    import enterpriseApi from "../../api/enterprise";
    import deviceTypeApi from "../../api/deviceType";
    export default {
        data: function () {
            return {
                form: {
                    useableCount: 0,
                    shareState: 1,
                    anymousState: 1
                },
                loading: false,
                types:[
                    {
                        name: "个人用户",
                        value: 1
                    },
                    {
                        name: "企业用户",
                        value: 0
                    }
                ],
                enterprises: [],
                deviceNames: [],
                deviceTypes: [],
                rules: {
                    epId: [{required: true, message: "请选择所属企业", trigger: "blur"}],
                    deviceTypeId: [{required: true, message: "请选择设备型号", trigger: "blur"}],
                    serialNo: [{required: true, message: "请输入产品序列号", trigger: "blur"}],
                    name: [{required: true, message: "请输入设备名称", trigger: "blur"}],
                    price: [{required: true, message: "请输入设备价格", trigger: "blur"}],
                    shareState: [{required: true, message: "请选择设备类型", trigger: "blur"}],
                    // deviceId: [{required: true, message: "请填写机器号", trigger: "blur"}],
                    snc: [{required: true, message: "请填写机器序号", trigger: "blur"}],
                    // uckey: [{required: true, message: "请填写ucKey3SKIP32", trigger: "blur"}],
                },
            }
        },
        mounted: function() {
            this.loadDevice();
            this.loadEnterprises();
            this.loadDeviceNames();
        },
        methods: {
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });

                    if(this.form.anymousState) {
                        this.$confirm('当前设备已开启匿名使用，确定继续该操作？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            deviceApi.update(this.form).then(result => {
                                loading.close();
                                this.$message({
                                    type: 'success',
                                    message: '更新成功!'
                                });
                                this.$router.back();
                            })
                        }).catch(() => loading.close());
                    } else {
                        deviceApi.update(this.form).then(result => {
                            loading.close();
                            this.$message({
                                type: 'success',
                                message: '更新成功!'
                            });
                            this.$router.back();
                        })
                    }


                })

            },
            loadDevice: function () {
                deviceApi.findById(this.$route.query.id).then(data => {
                    this.form = data;
                    deviceTypeApi.findByName(this.form.name).then(res => this.deviceTypes = res);
                })
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;
                })
            },
            loadDeviceNames: function() {
                deviceTypeApi.listNames().then(res => {
                    this.deviceNames = res;
                });
            },
            onNameSelect: function() {
                this.form = {...this.form, deviceTypeId: ""}
                deviceTypeApi.findByName(this.form.name).then(res => this.deviceTypes = res);
            },
            onEpChange: function () {
                console.log(this.form.epId)
                const epId = this.form.epId;
                if(epId) {
                    this.form = {
                        ...this.form,
                        standardId: null
                    }
                    deviceTypeApi.getByEpId(epId).then(res => this.standards = res);
                }
            }
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
